module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"see_all":"查看全部評價"}}')
  delete Component.options._Ctor
}
